(function () {
  'use strict';

  const { BaseCarousel, layout } = window.Universe;

  class ProductReviewsCarousel {
    constructor(section) {
      if (section) {
        this.init(section);
      }
    }

    setup() {
      const hasAutoplay = this.DOM.section.getAttribute('data-autoplay') === '';
      this.autoplayDelay = Number(this.DOM.section.getAttribute('data-autoplay-delay')) || 4;

      this.instance = new BaseCarousel({
        wrap: this.DOM.section,
        carouselOptions: {
          containScroll: 'trimSnaps',
          breakpoints: {
            '(min-width: 1024px)': {
              align: 'start',
              loop: true,
              watchDrag: true,
            },
            '(max-width: 1023px)': {
              align: 'start',
              loop: true,
              watchDrag: true,
            },
            '(max-width: 767px)': {
              align: 'center',
              loop: true,
              watchDrag: true,
            },
          },
        },
        autoPlayOnInit: false,
        withAutoPlay: hasAutoplay,
        autoPlayDelay: this.autoplayDelay * 1000,
        onReady: () => {
          this.instance.instance.on('select', this._onChangeSlide);

          if (this.DOM.prev.length) {
            for (let i = 0; i < this.DOM.prev.length; i++) {
              this.DOM.prev[i].addEventListener('click', this._onPrev);
            }
          }

          if (this.DOM.next.length) {
            for (let i = 0; i < this.DOM.next.length; i++) {
              this.DOM.next[i].addEventListener('click', this._onNext);
            }
          }

          if (hasAutoplay) {
            this.startAutoPlay();
          }
        },
      });
    }

    stopAutoPlay() {
      const plugins = this.instance && this.instance.instance ? this.instance.instance.plugins() : null;
      const autoplay = plugins ? plugins.autoplay : null;
      if (autoplay) {
        autoplay.stop();
      }
    }

    startAutoPlay() {
      const plugins = this.instance && this.instance.instance ? this.instance.instance.plugins() : null;
      const autoplay = plugins ? plugins.autoplay : null;
      if (autoplay) {
        autoplay.play();
      }
    }

    destroy() {
      if (this.DOM) {
        if (this.DOM.prev.length) {
          for (let i = 0; i < this.DOM.prev.length; i++) {
            this.DOM.prev[i].removeEventListener('click', this._onPrev);
          }
        }

        if (this.DOM.next.length) {
          for (let i = 0; i < this.DOM.next.length; i++) {
            this.DOM.next[i].removeEventListener('click', this._onNext);
          }
        }
        this.stopAutoPlay();
        if (this.instance) this.instance.destroy();

        this.instance = undefined;
        this.DOM = undefined;
      }
    }

    init(section) {
      this.DOM = {};
      this.DOM.section = section;
      this.DOM.prev = this.DOM.section.querySelectorAll('.js-carousel-prev');
      this.DOM.next = this.DOM.section.querySelectorAll('.js-carousel-next');

      this.activeIndex = layout.device >= 1 ? 0 : 1;

      this._onChangeSlide = () => {
        const nextIndex = this.instance.instance.selectedScrollSnap();
        this.stopAutoPlay();
        this.activeIndex = nextIndex;
      };

      this._onPrev = () => {
        this.instance.instance.scrollPrev();
      };

      this._onNext = () => {
        this.instance.instance.scrollNext();
      };

      this.setup();
    }
  }

  window.Universe.ProductReviewsCarousel = ProductReviewsCarousel;
})();
